<div class="container">
	<h2>{{{JspPublicCodes_JSP_MY_SETTINGS_CHANGES_SUCCESSFUL}}}</h2>
	<p>{{{JspPublicCodes_JSP_MY_SETTINGS_CHANGES_APPLIED}}}</p>
	<a href="{{contextPath}}/home" class="btn btn-primary"><i class="fa fa-angle-left" aria-hidden="true"></i> {{{JspPublicCodes_JSP_BACK_TO_PREVIOUS_PAGE}}}</a>
</div>